import React from "react";
import { Badge, Container, Text } from "./styles";

const DEFAULT_BADGE_COLOR = "#FFC700";
const DEFAULT_BADGE_BORDER_COLOR = "#FF9900";

interface BannerProps {
	text: string | undefined;
	text2: string | undefined;
	color?: string;
	borderColor?: string;
}

export const InfoBanner: React.FC<BannerProps> = ({
	text,
	text2,
	color = DEFAULT_BADGE_COLOR,
	borderColor = DEFAULT_BADGE_BORDER_COLOR
}) => {
	return (
		<Container>
			<Badge $color={color} $borderColor={borderColor} />
			<Text>
				<span className="text">{text}</span>
				<span className="text2">{text2}</span>
			</Text>
		</Container>
	);
};
